import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { apiGet } from '../../../../api/queries/apiGet';
import { API_BASE_URL } from '../constants/consts';
import { authFirewallQueryKeys } from '../constants/queryKeys';
import type { ApiError } from '../types';
import { PolicyCountByStatus } from '../../types';

const END_POINT = '/metrics/denyPolicies';

type PolicyCountByStatusDto = PolicyCountByStatus;

const convertToDenyPolicyByStatus = (data: PolicyCountByStatusDto): PolicyCountByStatus => {
    return {
        total: data.total,
        active: data.active,
        disabled: data.disabled
    };
};

const fetchDenyPolicies = async (): Promise<PolicyCountByStatusDto> => {
    const data = await apiGet<PolicyCountByStatusDto>(`${API_BASE_URL}${END_POINT}`);
    return data;
};

export const useDenyPolicies = (): UseQueryResult<PolicyCountByStatus, ApiError> => {
    return useQuery({
        queryKey: authFirewallQueryKeys.denyPolicies(),
        queryFn: () => fetchDenyPolicies(),
        select: convertToDenyPolicyByStatus
    });
};
